<template>
  <div class="delete-personal-data-container">
    <!-- <header class="modal-header"><h5 class="modal-title">{{ $t("deletePersonalDataRequestTitle") }}</h5><button type="button" aria-label="Close" class="close">×</button></header> -->
    <!-- <div class="d-flex justify-content-between align-items-center mb-4 header-zone"> -->
      <!-- <h2 class="form-title m-0">{{ $t("deletePersonalDataRequestTitle") }}</h2>
      <button type="button" class="close-btn" @click="$bvModal.hide(modalId)">
        <i class="fa fa-close"></i>
      </button>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide(modalId)">×</button>
    </div> -->

    <div class="description-text mb-4">
      {{ $t("deletePersonalDataDescription1") }}
      {{ $t("deletePersonalDataDescription2") }} <strong>{{ $t("deletePersonalDataPolicyArticle") }}</strong> {{ $t("deletePersonalDataDescription3") }}
      <a href="https://vnptai.io/vi/baovedulieucanhan" target="_blank" class="policy-link">{{ $t("personalDataProtectionPolicy") }}</a> {{ $t("deletePersonalDataDescription4") }}
      
      <div style="color: #000!important;font-weight: 500!important;margin-top:16px">{{ $t("deletePersonalDataDescription5") }}</div>
    </div>

    <b-form @submit.prevent="onConfirmDelete" class="delete-form">
      <!-- <b-form-group
        label-cols-md="3"
        label-class="form-label"
        class="mb-3 mb-md-4"
      >
        <template #label>
          {{ $t("fullName") }} <span class="text-danger">(*)</span>
        </template>
        <b-form-input v-model="formData.fullName" :placeholder="$t('namePlaceHolder')" required></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-md="3"
        label-class="form-label"
        class="mb-3 mb-md-4"
      >
        <template #label>
          {{ $t("phoneNumber") }} <span class="text-danger">(*)</span>
        </template>
        <b-form-input v-model="formData.phone" type="tel" :placeholder="$t('phonePlaceHolder')" required></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-md="3"
        label-class="form-label"
        class="mb-3 mb-md-4"
      >
        <template #label>
          {{ $t("email") }} <span class="text-danger">(*)</span>
        </template>
        <b-form-input v-model="formData.email" type="email" :placeholder="$t('emailPlaceHolder')" required></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-md="3"
        label-class="form-label align-self-start pt-md-2"
        class="mb-3 mb-md-4"
      >
        <template #label>
          {{ $t("requestLabel") }} <span class="text-danger">(*)</span>
        </template>
        <b-form-textarea v-model="formData.requestContent" :placeholder="$t('requestPlaceholder')" rows="4" required></b-form-textarea>
      </b-form-group> -->

      <div class="d-flex justify-content-center mt-4">
        <b-button type="submit" class="btn-submit-request">
          {{ $t("submitRequest") }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<style lang="scss">
.delete-personal-data-modal-custom {
  .modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    background: #ffffff;
  }

  .modal-header {
    .modal-title {
      font-weight: 700 !important;
    }
  }

  .modal-body {
    padding: 20px 12px;
  }
}

.delete-personal-data-container {
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #1a1a1a;

  .header-zone {
    .form-title {
      font-size: 22px;
      font-weight: 700;
      color: #000000;
   
    }
    .close-btn {
      background: none;
      border: none;
      font-size: 28px;
      color: #333;
      cursor: pointer;
      line-height: 1;
      padding: 0;
      &:hover {
        color: #000;
      }
    }
  }

  .description-text {
    font-size: 16px;
    line-height: 1.6;
    color: #000000;
    text-align: left;

    .policy-link {
      color: #0056b3;
      text-decoration: underline;
      font-weight: 600;
      &:hover {
        color: #003d80;
      }
    }
  }

  .delete-form {
    .form-label {
      font-size: 16px;
      font-weight: 500;
      color: #1a1a1a;
      text-align: left;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
    }

    // Tùy chỉnh giao diện ô input chuẩn theo hình vẽ
    .form-control {
      border: 1px solid #cce0ff;
      background-color: #f8faff;
      border-radius: 8px;
      height: 46px;
      font-size: 15px;
      color: #333;
      padding: 10px 16px;
      transition: all 0.2s ease;

      &::placeholder {
        color: #8c9ba5;
      }

      &:focus {
        background-color: #fff;
        border-color: #0056b3;
        box-shadow: 0 0 0 3px rgba(0, 86, 179, 0.15);
      }
    }

    // Riêng cho ô textarea nhập nội dung yêu cầu
    textarea.form-control {
      height: auto;
      resize: none;
    }
  }

  // Style nút "Gửi yêu cầu" màu xanh dương đậm
  .btn-submit-request {
    background-color: #0052a3;
    border-color: #0052a3;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    padding: 12px 48px;
    border-radius: 8px;
    min-width: 200px;
    transition: all 0.2s ease;

    &:hover, &:focus, &:active {
      background-color: #003d7a !important;
      border-color: #003d7a !important;
      box-shadow: 0 4px 12px rgba(0, 82, 163, 0.3) !important;
    }
  }
}

// Responsive cho màn hình mobile (labels sẽ nhảy lên trên input)
@media (min-width: 768px) {
  .delete-personal-data-container {
    .form-label {
      height: 46px; // Khớp với chiều cao của form-control để căn giữa label theo dòng
      margin-bottom: 0;
    }
    .align-self-start {
      height: auto !important;
    }
  }
}
</style>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as policyService from "@/service/policyService";
import * as userService from "@/service/userService";

@Component
export default class DeletePersonalDataModal extends BaseComponent {
  @Prop({ type: String, required: true }) readonly modalId!: string;

  // Khai báo data lưu trữ dữ liệu form khách hàng nhập
  private formData = {
    fullName: '',
    phone: '',
    email: '',
    requestContent: ''
  };

  async onConfirmDelete() {
    try {
      this.showLoading();
      
      await policyService.requestPersonalDataDeletion();
      
      this.$bvModal.hide(this.modalId);
      this.toastSuccessDelay(this.$t("submitRequestSuccess") as string);
      
      const tout = setTimeout(() => {
        this.hideLoading();
        clearInterval(tout);
      }, 500);
    } catch (e) {
      this.toastError(e);
    } finally {
      this.hideLoading();
    }
  }
}
</script>
